<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        
        <div class="container-fluid">
          
          <div class="row">
            <!-- <div class="col-sm-6 col-lg-3">
              <div class="card bg-primary">
                <div class="card-body clearfix">
                  <div class="pull-right">
                    <p class="h6 text-white m-t-0">我的收入</p>
                    <p class="h3 text-white m-b-0">102,125.00</p>
                  </div>
                  <div class="pull-left"> <span class="img-avatar img-avatar-48 bg-translucent"><i class="mdi mdi-currency-cny fa-1-5x"></i></span> </div>
                </div>
              </div>
            </div> -->
            
            <div class="col-sm-6 col-lg-4">
              <div class="card bg-danger">
                <div class="card-body clearfix">
                  <div class="pull-right">
                    <p class="h6 text-white m-t-0">我的积分</p>
                    <p class="h3 text-white m-b-0">{{payPoints}}</p>
                  </div>
                  <div class="pull-left"> <span class="img-avatar img-avatar-48 bg-translucent"><i class="mdi mdi-account fa-1-5x"></i></span> </div>
                </div>
              </div>
            </div>
            
            <div class="col-sm-6 col-lg-4">
              <div class="card bg-success">
                <div class="card-body clearfix">
                  <div class="pull-right">
                    <p class="h6 text-white m-t-0">下载总量</p>
                    <p class="h3 text-white m-b-0">{{total}}</p>
                  </div>
                  <div class="pull-left"> <span class="img-avatar img-avatar-48 bg-translucent"><i class="mdi mdi-arrow-down-bold fa-1-5x"></i></span> </div>
                </div>
              </div>
            </div>
            
            <div class="col-sm-6 col-lg-4">
              <div class="card bg-purple">
                <div class="card-body clearfix">
                  <div class="pull-right">
                    <p class="h6 text-white m-t-0">新增留言</p>
                    <p class="h3 text-white m-b-0">{{commentTotal}} 条</p>
                  </div>
                  <div class="pull-left"> <span class="img-avatar img-avatar-48 bg-translucent"><i class="mdi mdi-comment-outline fa-1-5x"></i></span> </div>
                </div>
              </div>
            </div>
          </div>
          
          
          <div class="row">
            
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header">
                  <h4>最新下载</h4>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>名称</th>
                          <th>分类</th>
                          <th>日期</th>
                          <!-- <th>类型</th> -->
                          <!-- <th>价格</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item,index in downList" :key="index">
                          <td>{{index + 1}}</td>
                          <td class="shou"  @click="enterDetail(item.docId, item.doclibId)">{{item.docName}}</td>
                          <td><a  target="_blank">{{item.doclibName}}</a></td>
                          <td>{{item.sysCreated}}</td>
                          <!-- <td><span class="label label-warning">JPG</span></td> -->
													<!-- <td>100元</td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
									<!-- 分页器 -->
									<div class="pagination">
										<Page class-name="page-class" :total="total" :page-size="10" @on-change="changePage" />
									</div>
                </div>
              </div>
            </div>
            
					
          </div>
					
					
          
        </div>
        
      </main>
      <!--End 页面主要内容-->
    </div>
  </div>
</template>


<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			payPoints: 0,
			total:0,
			commentTotal: 0,
			downList: [] // 最新下载记录
		}
  },
	
	components: {
		userLeft,
		userHead
	},

  created () {
		this.checkToken()
		this.downrecord()
		this.commentdata()
	},
	
	mounted () {
		
	},

  methods: {
		// 验证token的时效性
		async checkToken () {
			// 验证token的时效性
			let _this = this
			const tokenState = await this.util.checkToken(localStorage.getItem('token'))
			_this.payPoints = tokenState.data.payPoints
		},
		
		changePage (page) {
			this.downrecord(page-1)
		},
		
		// 下载记录
		async downrecord (page=0) {
			let _this = this
			const res = await _this.get_res('/members/downloads', {page,size:10})
			_this.downList = res.content
			_this.total = res.totalElements
		},
		
		// 浏览条数
		async commentdata () {
			let _this = this
			const res = await _this.post('/spc/discuss/getDiscussListByUser.do?userId=' + localStorage.getItem('id'))
			_this.commentTotal = res.data.totalElements
		},
		
		// 跳转
		enterDetail (id,tid) {
				if (tid == 25 || tid == 837) {
					let link = this.$router.resolve({path:'/img_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else if (tid == 28) {
					let link = this.$router.resolve({path:'/audio_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else {
					let link = this.$router.resolve({path:'/video_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				}
		},
	}
}
</script>

<style lang="less" scoped>
</style>
